import { buttonRecipe } from './button.recipe';

export const recipes = {
	button: buttonRecipe,
};
